import { render, staticRenderFns } from "./SafeTips.vue?vue&type=template&id=586094c6&scoped=true&"
import script from "./SafeTips.vue?vue&type=script&lang=js&"
export * from "./SafeTips.vue?vue&type=script&lang=js&"
import style0 from "./SafeTips.vue?vue&type=style&index=0&id=586094c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586094c6",
  null
  
)

export default component.exports